import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    Chip,
    CircularProgress,
    Paper,
    Grid,
    Divider,
    Tooltip,
    IconButton,
    Alert,
} from "@mui/material";

import { useEffect, useState } from "react";
import * as XLSX from 'xlsx';
import { callAPI, getLocalValue, LoacalVariables, Method } from "../../commonFunctions/CommonFunctions";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { AccountBalance, Approval, Block, CheckCircle, CurrencyRupee, Download, Edit, Assignment, InfoOutlined } from "@mui/icons-material";
import WSLoadingOverlay from "../../Components/WSLoadingOverlay";
// import http from "../../commonFunctions/httpClient";

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import BackButton from "../components/backButton";
import LoanRepaymentTable from "../Repayment/Table";
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import { useForm } from "react-hook-form";

import dayjs from "dayjs";
import { useAuth } from "../../StateManagement/authContext";

import EmiSchedules from "./EmiSchedules";
import EmiDialog from "./EmiDialog";
import EmiCorrectionDialog from "./EmiCorrectionDialog";
import EmiApproveOrReject from "./EmiApproveOrReject";
import LoanRejectDialog from "./LoanRejectDialog";
import ActionButton from "../components/actionButton";
import MoratoriumData from "./MoratoriumData";
// import LoanStatement from "../Reports/LoanStatement";

export type EmiItem = {
    month: number;
    dueDate: string;
    emiAmount: number;
    interest: number;
    principal: number;
    balance: number;
    status: StatusType;
    repaidAmount: number;
    repaidPrincipal: number;
    repaidInterest: number;
    accumulatedInterest: number,
    includesOverdueInterest: boolean,
    totalInterestDisplay: number,
    isMoratoriumPeriod: boolean,
    actualPayment?: {
        amount: number;
        emiPortion: number;
        prepaymentPortion: number;
        receiptNumbers: string[];
    };
    explanation?: string;
};

export type StatusType = 'Paid' | 'Partial' | 'Unpaid' | 'Overdue' | 'Moratorium';

export type EmiData = {
    emi: number;
    totalPayment: number;
    totalInterest: number;
    schedule: EmiItem[];
    // Add summary fields
    outstandingBalance: number;
    totalRepayments: number;
    totalPrepayments: number;
};

export type EmiFormValues = {
    paymentType: string;
    repaymentDate: string;
    receiptNumber: string;
    amount: number;
    principal: number;
    interestRate: number;
    remarks?: string;
};


const LoanDetailPage = () => {
    const [submitting, setSubmitting] = useState(false);
    const [loadingCorrection, setLoadingCorrection] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [statusChanging, setStatusChanging] = useState(false);
    const [loanData, setLoanData] = useState<any>(null);
    const [fetchRepayment, setFetchRepayment] = useState<boolean>(false);

    const [openPayDialog, setOpenPayDialog] = useState(false);
    const [selectedEmi, setSelectedEmi] = useState<any>(null);
    const [selectedEmis, setSelectedEmis] = useState<any[]>([]);
    const [payingBulk, setPayingBulk] = useState<boolean>(false);
    const [corrections, setCorrections] = useState([]);
    // const [rejectedReason, setRejectedReason] = useState('');

    //loan reject stats;
    const [openRejectModal, setOpenRejectModal] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');

    const [emiData, setEmiData] = useState<EmiData>({
        emi: 0,
        totalPayment: 0,
        totalInterest: 0,
        outstandingBalance: 0,
        totalPrepayments: 0,
        totalRepayments: 0,
        schedule: []
    });

    const [correctionOpen, setCorrectionOpen] = useState(false);
    const [selectedRepayment, setSelectedRepayment] = useState<any>(null);
    const [correctionForm, setCorrectionForm] = useState({
        newAmount: '',
        newPrincipal: '',
        newInterest: '',
        reason: '',
    });


    const [page, setPage] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState<number>(10);

    const { id } = useParams();
    const { showMessage } = useSnackbar();
    const { refresh } = useAuth();

    const getEndOfCurrentMonth = () => {
        const today = new Date();
        return dayjs(new Date(today.getFullYear(), today.getMonth() + 2, 0)).format("MM/DD/YYYY")
    };

    const { setValue, handleSubmit, control, watch, reset } = useForm<EmiFormValues>({
        defaultValues: {
            repaymentDate: getEndOfCurrentMonth(),
            principal: 0,
            interestRate: 0,
        }
    });
    const navigate = useNavigate();
    const userType = getLocalValue(LoacalVariables.UserType);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await callAPI(`loans/getBy/${id}`, Method.GET);
                console.log('response from loan by data',res.loan)
                setLoanData(res.loan);
            } catch (error: any) {
                console.error("Failed to fetch data:", error);
                if (error.message === 'GlobalHandledError') return;
            } finally { setLoading(false) }
        };

        fetchData();
    }, [id, statusChanging, refresh]);

    const fetchEmiSchedule = async () => {
        try {
            const res = await callAPI(`loans/emi-schedule/${loanData._id}`, Method.GET);

            console.log('emi schedule is', res);

            setEmiData({
                emi: res.emi,
                totalPayment: res.totalPayment,
                totalInterest: res.totalInterest,
                schedule: res.schedule || [],
                outstandingBalance: res.outstandingBalance,
                totalRepayments: res.totalRepayments,
                totalPrepayments: res.totalPrepayments
            });
        } catch (err) {
            console.error("Failed to fetch EMI schedule", err);
        }
    };

    useEffect(() => {
        if (loanData?.status === 'disbursed') {
            fetchEmiSchedule();
        }
    }, [loanData, refresh]);

    useEffect(() => {
        if (selectedEmi) {
            reset({
                // repaymentDate: dayjs(new Date()).format("MM/DD/YYYY"),
                repaymentDate: dayjs(selectedEmi.dueDate).format("MM/DD/YYYY"),
                receiptNumber: '',
                amount: selectedEmi.emiAmount,
                principal: selectedEmi.principal,
                interestRate: selectedEmi.interest,
                remarks: ''
            });
        }
    }, [selectedEmi, reset]);


    const getEmiMonthIndex = (repaymentDateStr: string, fundTransferDateStr: string) => {
        const repaymentDate = new Date(repaymentDateStr);
        const fundTransferDate = new Date(fundTransferDateStr);

        // First EMI is at end of *next* month from fund transfer
        const firstEmiDue = new Date(fundTransferDate.getFullYear(), fundTransferDate.getMonth() + 1, 1);
        firstEmiDue.setMonth(firstEmiDue.getMonth() + 1);
        firstEmiDue.setDate(0); // Last day of that month

        // Now calculate how many EMIs passed between firstEmiDue and repaymentDate
        const monthsBetween =
            (repaymentDate.getFullYear() - firstEmiDue.getFullYear()) * 12 +
            (repaymentDate.getMonth() - firstEmiDue.getMonth());

        return Math.max(0, Math.min(monthsBetween, emiData.schedule.length - 1));
    };


    const repaymentDate = watch("repaymentDate");

    useEffect(() => {
        if (!repaymentDate || !emiData.schedule.length || !loanData?.fundTransferDate) return;

        const monthIndex = getEmiMonthIndex(repaymentDate, loanData.fundTransferDate);
        const currentEmi = emiData.schedule[monthIndex];

        if (currentEmi) {

            setValue("principal", currentEmi.principal);
            setValue("amount", currentEmi.emiAmount);
            setValue("interestRate", currentEmi.interest);
        }
    }, [repaymentDate, emiData, loanData]);

    useEffect(() => {
        const fetchCorrections = async () => {
            const res = await callAPI(`repayments/repayment-corrections/get?status=pending&loanId=${loanData?._id}`, Method.GET);

            setCorrections(res.data);
        };
        if (userType === 'district') {
            fetchCorrections();
        }
    }, [loanData, emiData]);


    if (loading)
        return (
            <Box height="80vh" display="flex" alignItems="center" justifyContent="center">
                <CircularProgress sx={{ color: "#4AD06E" }} />
            </Box>
        );

    if (!loanData) return <Typography>No Loan Found</Typography>;


    const handleDownloadAll = () => {
        loanData.documents.forEach((doc: any) => {
            window.open(doc.fileUrl, "_blank");
        });
    };

    const handleAction = async (action: "Disburse" | "Sanction" | "Complete" | "Reject") => {
        if (action === "Disburse") {
            navigate(`/loan/request/disburse/${loanData?._id}`)
        } else if (action === "Sanction") {
            navigate(`/loan/request/sanction/${loanData?._id}`)
        }
        else if (action === "Complete") {
            setStatusChanging(true);
            try {
                const response: any = await callAPI(
                    `loans/complete/update/${loanData._id}`,
                    Method.PATCH,
                );
                if (response.success) {
                    showMessage(response.message, 'success');
                }
            } catch (error: any) {
                if (error.message === 'GlobalHandledError') return;
                showMessage(
                    error.response?.data.message || "An unexpected error occurred",
                    "error"
                );
            } finally {
                setStatusChanging(false);
            }
        }
        else if (action === "Reject") {
            setOpenRejectModal(true)
        }
    };


    //this for loan rejection;
    const handleRejectLoan = async () => {
        if (!rejectionReason) {
            showMessage('Please provide a rejection reason.', 'warning');
            return;
        }

        setStatusChanging(true);
        try {
            const response: any = await callAPI(
                `loans/update/status/${loanData._id}`,
                Method.PATCH,
                { status: "rejected", reasonForReject: rejectionReason }
            );
            if (response.success) {
                showMessage(response.message, 'success');
                setOpenRejectModal(false);  // Close the modal after successful rejection
            }
        } catch (error: any) {
            if (error.message === 'GlobalHandledError') return;
            showMessage(
                error.response?.data.message || "An unexpected error occurred",
                "error"
            );
        } finally {
            setStatusChanging(false);
        }
    };

    const handleCloseRejectModal = () => {
        setOpenRejectModal(false);  // Close modal without taking any action
    };


    const handleDownload = async (format: 'pdf' | 'excel') => {
        try {
            setDownloading(true);

            // if (format === 'excel') {
            //     const response: AxiosResponse<Blob> = await http.downloadFile(
            //         `loans/emi-schedule/${loanData._id}/${format}`,
            //         { responseType: 'blob' }
            //     );

            //     const blob = new Blob([response.data], {
            //         type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            //     });

            //     const url = window.URL.createObjectURL(blob);
            //     const a = document.createElement('a');
            //     a.href = url;
            //     a.download = `EMI_Schedule_${loanData._id}.xlsx`;
            //     document.body.appendChild(a);
            //     a.click();
            //     a.remove();
            //     window.URL.revokeObjectURL(url);

            // } server side option;
            if (format === 'excel') {
                const wb = XLSX.utils.book_new();

                // Format currency for Indian Rupees
                const formatCurrency = (amount: number) =>
                    amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                // Sheet 1: Loan Summary
                const loanSummaryData = [
                    ['LOAN DETAILS REPORT', '', '', '', ''],
                    ['Generated on:', new Date().toLocaleDateString(), '', '', ''],
                    ['', '', '', '', ''],
                    ['APPLICANT INFORMATION', '', '', '', ''],
                    ['Applicant Name:', loanData.applicantName, '', 'Loan ID:', loanData.loanId],
                    ['Mobile:', loanData.mobile, '', 'Reference No:', loanData.referenceNumber],
                    ['WhatsApp:', loanData.whatsappNumber || '-', '', 'Loan Type:', loanData.isGroupLoan ? 'Group Loan' : 'Individual Loan'],
                    ['Enterprise Name:', loanData.enterpriseName, '', 'Status:', loanData.status.toUpperCase()],
                    ['NHG Member:', loanData.nhgMemberName || '-', '', 'CDS:', loanData.cds?.name || '-'],
                    ['Relationship:', loanData.relationshipWithNhgMember || '-', '', 'Block:', loanData.block?.name || '-'],
                    ['NHG Name:', loanData.nhgName || '-', '', 'District:', loanData.district?.name || '-'],
                    ['ADS Name:', loanData.adsName || '-', '', 'Created By:', loanData.createdBy?.name || '-'],
                    ['', '', '', '', ''],
                    ['LOAN FINANCIAL DETAILS', '', '', '', ''],
                    ['Applied Amount:', `₹${formatCurrency(loanData.appliedAmount)}`, '', 'Sanctioned Amount:', `₹${formatCurrency(loanData.sanctionedCefAmount)}`],
                    ['Amount Received:', `₹${formatCurrency(loanData.amountReceived)}`, '', 'Interest Rate:', `${loanData.interestRate}%`],
                    ['Repayment Months:', `${loanData.repaymentMonths} months`, '', 'Sanctioned Date:', new Date(loanData.sanctionedDate).toLocaleDateString()],
                    ['Disbursed Date:', new Date(loanData.fundTransferDate).toLocaleDateString(), '', 'Created On:', new Date(loanData.createdAt).toLocaleDateString()],
                    ['', '', '', '', ''],
                    ['EMI SUMMARY', '', '', '', ''],
                    ['Monthly EMI:', `₹${formatCurrency(emiData.emi)}`, '', 'Total Payment:', `₹${formatCurrency(emiData.totalPayment)}`],
                    ['Total Interest:', `₹${formatCurrency(emiData.totalInterest)}`, '', 'Total Repayments:', `₹${formatCurrency(emiData.totalRepayments)}`],
                    ['Outstanding Balance:', `₹${formatCurrency(emiData.outstandingBalance)}`, '', '', '']
                ];

                const ws1 = XLSX.utils.aoa_to_sheet(loanSummaryData);
                XLSX.utils.book_append_sheet(wb, ws1, "Loan Summary");

                // Sheet 2: EMI Schedule
                const emiHeaders = [['Month', 'Due Date', 'EMI Amount (₹)', 'Principal (₹)', 'Interest (₹)', 'Balance (₹)', 'Status', 'Amount Repaid (₹)', 'Principal Repaid (₹)', 'Interest Repaid (₹)']];

                const emiRows = emiData.schedule.map((item: any) => [
                    item.month,
                    new Date(item.dueDate).toLocaleDateString(),
                    item.emiAmount,
                    item.principal,
                    item.interest,
                    item.balance,
                    item.status,
                    item.repaidAmount || 0,
                    item.repaidPrincipal || 0,
                    item.repaidInterest || 0
                ]);

                const emiDataSheet = [...emiHeaders, ...emiRows];
                const ws2 = XLSX.utils.aoa_to_sheet(emiDataSheet);
                XLSX.utils.book_append_sheet(wb, ws2, "EMI Schedule");

                // Sheet 3: Status History
                const statusHeaders = [['Status', 'Updated By', 'Remarks', 'Date']];
                const statusRows = loanData.statusHistory.map((item: any) => [
                    item.status,
                    item.updatedBy,
                    item.remarks,
                    new Date(item.date).toLocaleDateString()
                ]);

                const statusDataSheet = [...statusHeaders, ...statusRows];
                const ws3 = XLSX.utils.aoa_to_sheet(statusDataSheet);
                XLSX.utils.book_append_sheet(wb, ws3, "Status History");

                // Sheet 4: Activity Log
                // const activityHeaders = [['Action', 'By Role', 'Message', 'Date']];
                // const activityRows = loanData.activityLog.map((item: any) => [
                //     item.action,
                //     item.by.role,
                //     item.message,
                //     new Date(item.date).toLocaleDateString()
                // ]);

                // const activityDataSheet = [...activityHeaders, ...activityRows];
                // const ws4 = XLSX.utils.aoa_to_sheet(activityDataSheet);
                // XLSX.utils.book_append_sheet(wb, ws4, "Activity Log");

                // Generate Excel file
                XLSX.writeFile(wb, `Loan_Details_${loanData.applicantName}_${loanData.loanId}.xlsx`);
            }
            else if (format === 'pdf') {


                const doc = new jsPDF();
                const pageWidth = doc.internal.pageSize.width;
                let yPosition = 15;

                doc.setFontSize(16);
                doc.setTextColor(33, 37, 41);

                // Header
                doc.text('LOAN DETAILS & EMI SCHEDULE REPORT', pageWidth / 2, yPosition, { align: 'center' });
                yPosition += 10;

                doc.setFontSize(10);
                doc.setTextColor(100, 100, 100);
                doc.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth - 15, yPosition, { align: 'right' });
                yPosition += 15;

                const formatCurrency = (amount: number) =>
                    `₹${amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

                // Section 1: Basic Applicant Information
                doc.setFontSize(12);
                doc.setTextColor(61, 82, 160);
                doc.text('APPLICANT INFORMATION', 15, yPosition);
                yPosition += 8;

                const applicantInfo = [
                    ['Applicant Name:', loanData.applicantName],
                    ['Mobile:', loanData.mobile],
                    ['WhatsApp:', loanData.whatsappNumber || '-'],
                    ['Enterprise Name:', loanData.enterpriseName],
                    ['NHG Member:', loanData.nhgMemberName || '-'],
                    ['Relationship:', loanData.relationshipWithNhgMember || '-'],
                    ['NHG Name:', loanData.nhgName || '-'],
                    ['ADS Name:', loanData.adsName || '-']
                ];

                autoTable(doc, {
                    startY: yPosition,
                    head: [],
                    body: applicantInfo,
                    theme: 'grid',
                    styles: {
                        fontSize: 10,
                        cellPadding: 3,
                        valign: 'middle',
                    },
                    columnStyles: {
                        0: { cellWidth: 50, fontStyle: 'bold' },
                        1: { cellWidth: 60 },
                    },
                });

                yPosition = (doc as any).lastAutoTable.finalY + 10;

                // Section 2: Loan Details
                doc.setFontSize(12);
                doc.setTextColor(61, 82, 160);
                doc.text('LOAN DETAILS', 15, yPosition);
                yPosition += 8;

                const loanDetails = [
                    ['Loan ID:', loanData.loanId],
                    ['Reference No:', loanData.referenceNumber],
                    ['Applied Amount:', formatCurrency(loanData.appliedAmount)],
                    ['Sanctioned Amount:', formatCurrency(loanData.sanctionedCefAmount)],
                    ['Amount Received:', formatCurrency(loanData.amountReceived)],
                    ['Interest Rate:', `${loanData.interestRate}%`],
                    ['Repayment Months:', `${loanData.repaymentMonths} months`],
                    ['Loan Type:', loanData.isGroupLoan ? 'Group Loan' : 'Individual Loan'],
                    ['Status:', loanData.status.toUpperCase()],
                    ['Sanctioned Date:', new Date(loanData.sanctionedDate).toLocaleDateString()],
                    ['Disbursed Date:', new Date(loanData.fundTransferDate).toLocaleDateString()]
                ];

                autoTable(doc, {
                    startY: yPosition,
                    head: [],
                    body: loanDetails,
                    theme: 'grid',
                    styles: {
                        fontSize: 10,
                        cellPadding: 3,
                        valign: 'middle',
                    },
                    columnStyles: {
                        0: { cellWidth: 55, fontStyle: 'bold' },
                        1: { cellWidth: 55 },
                    },
                });

                yPosition = (doc as any).lastAutoTable.finalY + 10;

                // Section 3: Administrative Information
                doc.setFontSize(12);
                doc.setTextColor(61, 82, 160);
                doc.text('ADMINISTRATIVE INFORMATION', 15, yPosition);
                yPosition += 8;

                const adminInfo = [
                    ['CDS:', loanData.cds?.name || '-'],
                    ['Block:', loanData.block?.name || '-'],
                    ['District:', loanData.district?.name || '-'],
                    ['Created By:', loanData.createdBy?.name || '-'],
                    ['Created On:', new Date(loanData.createdAt).toLocaleDateString()]
                ];

                autoTable(doc, {
                    startY: yPosition,
                    head: [],
                    body: adminInfo,
                    theme: 'grid',
                    styles: {
                        fontSize: 10,
                        cellPadding: 3,
                        valign: 'middle',
                    },
                    columnStyles: {
                        0: { cellWidth: 40, fontStyle: 'bold' },
                        1: { cellWidth: 70 },
                    },
                });

                yPosition = (doc as any).lastAutoTable.finalY + 10;

                // Section 4: EMI Summary
                doc.setFontSize(12);
                doc.setTextColor(61, 82, 160);
                doc.text('EMI SUMMARY', 15, yPosition);
                yPosition += 8;

                const emiSummary = [
                    ['Monthly EMI:', formatCurrency(emiData.emi)],
                    ['Total Payment:', formatCurrency(emiData.totalPayment)],
                    ['Total Interest:', formatCurrency(emiData.totalInterest)],
                    ['Total Repayments:', formatCurrency(emiData.totalRepayments)],
                    ['Outstanding Balance:', formatCurrency(emiData.outstandingBalance)]
                ];

                autoTable(doc, {
                    startY: yPosition,
                    head: [],
                    body: emiSummary,
                    theme: 'grid',
                    styles: {
                        fontSize: 10,
                        cellPadding: 3,
                        valign: 'middle',
                    },
                    columnStyles: {
                        0: { cellWidth: 55, fontStyle: 'bold' },
                        1: { cellWidth: 55 },
                    },
                });

                yPosition = (doc as any).lastAutoTable.finalY + 15;

                // Section 5: Detailed EMI Schedule
                doc.setFontSize(12);
                doc.setTextColor(61, 82, 160);
                doc.text('DETAILED EMI SCHEDULE', 15, yPosition);
                yPosition += 8;

                const headers = [
                    ['Month', 'Due Date', 'EMI (₹)', 'Principal (₹)', 'Interest (₹)', 'Balance (₹)', 'Status']
                ];

                const rows = emiData.schedule.map((item: any) => [
                    item.month,
                    new Date(item.dueDate).toLocaleDateString(),
                    item.emiAmount.toFixed(2),
                    item.principal.toFixed(2),
                    item.interest.toFixed(2),
                    item.balance.toFixed(2),
                    item.status
                ]);

                autoTable(doc, {
                    head: headers,
                    body: rows,
                    startY: yPosition,
                    headStyles: {
                        fillColor: [61, 82, 160],
                        textColor: 255,
                        fontStyle: 'bold',
                        fontSize: 9,
                    },
                    styles: {
                        fontSize: 8,
                        cellPadding: 2,
                    },
                    columnStyles: {
                        0: { cellWidth: 15 },
                        1: { cellWidth: 25 },
                        2: { cellWidth: 20 },
                        3: { cellWidth: 20 },
                        4: { cellWidth: 20 },
                        5: { cellWidth: 25 },
                        6: { cellWidth: 20 },
                    },
                    pageBreak: 'auto',
                    margin: { top: 10 }
                });

                // Add footer with page numbers
                const pageCount = (doc as any).internal.getNumberOfPages();
                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setFontSize(8);
                    doc.setTextColor(100, 100, 100);
                    doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, doc.internal.pageSize.height - 10, { align: 'center' });
                    doc.text(`Confidential - ${loanData.applicantName}`, 15, doc.internal.pageSize.height - 10);
                }

                doc.save(`Loan_Details_${loanData.applicantName}_${loanData.loanId}.pdf`);
            }
        } catch (error: any) {
            console.error('Download failed:', error);
            if (error.message === 'GlobalHandledError') return;
            showMessage(
                error.response?.data.message || 'An unexpected error occurred',
                'error'
            );
        } finally {
            setDownloading(false);
        }
    };

    const handleEditLoan = (loanId: string) => { navigate(`/loan/request/${loanId}`) }

    let isEditable = userType === 'admin' || userType === 'district'
    const getStatusColor = (status: string) => {
        switch (status) {
            case "disbursed":
                return "info";
            case "rejected":
                return "error";
            case "sanctioned":
                return "success";
            case "completed":
                return "warning";
            case "pending":
            default:
                return "default"; // or "primary" if you want blue
        }
    };

    const handleRepaymentClick = (item: any) => {
        // let amountToPay = item.emiAmount;

        // If there's accumulated interest, add it to the payment
        // if (item.includesOverdueInterest && item.accumulatedInterest) {
        //     amountToPay = item.emiAmount + item.accumulatedInterest;
        // }
        // setSelectedEmi({
        //     ...item,
        //     amount: amountToPay
        // });
        setSelectedEmi(item);
        setOpenPayDialog(true);
    };

    const handleSubmitCorrectionRequest = async () => {

        try {
            const request = {
                repaymentId: selectedRepayment._id,
                newAmount: Number(correctionForm.newAmount),
                newPrincipal: Number(correctionForm.newPrincipal),
                newInterest: Number(correctionForm.newInterest),
                reason: correctionForm.reason,
            }

            const response: any = await callAPI(
                `repayments/repayment-corrections`,
                Method.POST,
                request
            );


            if (response.success) {
                showMessage(response.message, "success");
            }
            setCorrectionOpen(false);
        } catch (error: any) {
            if (error.message === 'GlobalHandledError') return;
            showMessage(
                error.response?.data.message || "An unexpected error occurred",
                "error"
            );
        }
    };


    const handleConfirmPayment = async (data: any) => {

        setSubmitting(true);
        try {
            const request = {
                loan: loanData._id,
                amount: Number(data.amount), // Total amount paid
                paymentType: data.paymentType,
                // principal: Number(data.principal || 0), // Optional
                // interestRate: Number(data.interestRate || 0), // Optional
                // repaymentDate: new Date(data.repaymentDate), // Date object
                repaymentDate: dayjs(data.repaymentDate).format("YYYY-MM-DD"),
                receiptNumber: data.receiptNumber, // String
                remarks: data.remarks || "",
            };

            const response: any = await callAPI("repayments/create", Method.POST, request);

            if (response.success) {
                await fetchEmiSchedule();
                showMessage(response.message, "success");
                setOpenPayDialog(false);
                // setFetchRepayment(true)
                setFetchRepayment(prev => !prev)
            }
        } catch (error: any) {
            if (error.message === 'GlobalHandledError') return;
            showMessage(
                error.response?.data.message || "An unexpected error occurred",
                "error"
            );
        } finally {
            setSubmitting(false);
        }
    };


    const handleCorrectionClick = (repayment: any) => {

        setSelectedRepayment(repayment.actualPayment);
        setCorrectionForm({
            newAmount: repayment.scheduledEMI,
            newPrincipal: repayment.scheduledPrincipal,
            newInterest: repayment.scheduledInterest,
            reason: '',
        });
        setCorrectionOpen(true);
    };

    const handleBulkRepayment = async (selectedItems: any[]) => {
        try {
            setPayingBulk(true);
            const res = await payBulkRepayments(loanData._id, selectedItems);
            if (res.success) {
                showMessage(
                    res.message,
                    "success"
                );
            }
            //  Refresh EMI data
            setStatusChanging(true);
            setSelectedEmis([]);
        } catch (error: any) {
            if (error.message === 'GlobalHandledError') return;
            showMessage(
                error.response?.data.message || "An unexpected error occurred",
                "error"
            );
        } finally {
            setPayingBulk(false);
        }
    };

    const payBulkRepayments = async (loanId: string, selectedEmis: any[]) => {
        const repayments = selectedEmis.map((emi) => ({
            amount: emi.emi,
            month: emi.month,
        }));

        const { data } = await callAPI("repayments/bulk/submit", Method.POST, {
            loanId,
            repayments,
        });

        return data;
    };

    const handleApprove = async (id: string) => {
        try {
            setLoadingCorrection(true)
            let response = await callAPI(`repayments/repayment-corrections/approve/${id}`, Method.PATCH);
            if (response.success) showMessage(response.message, "success");
            setCorrections((prev) => prev.filter((c: any) => c._id !== id));
        } catch (error: any) {
            if (error.message === 'GlobalHandledError') return;
            showMessage(
                error.response?.data.message || "An unexpected error occurred",
                "error"
            );
        } finally {
            setLoadingCorrection(false)
        }
    };

    //this for reject repayment request;
    const handleRejectRepaymentRequest = async (id: string) => {
        try {
            setLoadingCorrection(true)
            let response = await callAPI(`repayments/repayment-corrections/reject/${id}`, Method.PATCH);
            if (response.success) showMessage(response.message, "success");
            setCorrections((prev) => prev.filter((c: any) => c._id !== id));
        } catch (error: any) {
            if (error.message === 'GlobalHandledError') return;
            showMessage(
                error.response?.data.message || "An unexpected error occurred",
                "error"
            );
        } finally {
            setLoadingCorrection(false)
        }
    };

    return (
        <Box p={3}>
            {/* User Header */}
            <BackButton />
            <Grid container spacing={3} mt={2}>
                {/* Left Panel */}
                <Grid item xs={12} md={4}>
                    <Box
                        sx={{
                            background: "linear-gradient(95.53deg, #4AD06E 0%, #08B1B6 100%)",
                            p: 2,
                            borderBottomRightRadius: "20px",
                            height: "5rem",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            position: "relative",
                        }}
                    >
                        <Typography variant="body1" fontWeight="bold" color={"white"}>
                            Loan Details
                        </Typography>
                        <CurrencyRupee
                            sx={{
                                fontSize: 60,
                                position: "absolute",
                                bottom: -40,
                                right: 20,
                                color: "#fff",
                                background: "linear-gradient(95.53deg, #4AD06E 0%, #08B1B6 100%)", // gradient applied
                                borderRadius: "50%",
                                boxShadow: 3,
                                p: 1,
                            }}
                        />
                    </Box>

                    {/* User Card */}
                    <Card
                        sx={{
                            borderRadius: 2,
                            mt: 7,
                            boxShadow: 1,
                        }}
                    >
                        <CardContent>
                            <Typography sx={{ fontSize: "16px" }} fontWeight="medium" gutterBottom>
                                Applicant Info
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Divider sx={{ my: 1 }} />
                                    <Typography sx={{ lineHeight: "24px" }} variant="body2">Name: {loanData.applicantName}</Typography>
                                    <Typography sx={{ lineHeight: "24px" }} variant="body2">Secondary Name: {loanData.secondApplicantName || "-"}</Typography>
                                    <Typography sx={{ lineHeight: "24px" }} variant="body2">Mobile: {loanData.mobile}</Typography>
                                    <Typography sx={{ lineHeight: "24px" }} variant="body2">WhatsApp: {loanData.whatsappNumber}</Typography>
                                </Grid>
                            </Grid>
                            <Chip
                                label={loanData.status.toUpperCase()}
                                color={getStatusColor(loanData.status)}
                                size="small"
                                sx={{ mb: 1, mt: 1 }}
                            />
                        </CardContent>
                    </Card>
                </Grid>

                {/* Right Panel */}
                <Grid item xs={12} md={8}>
                    <Card
                        sx={{
                            position: 'relative', // required for absolute positioning
                            borderRadius: 2,
                            p: 3,
                            boxShadow: 1,
                        }}
                    >
                        {/* Edit Button - Top Right */}
                        {userType === 'block' && ["pending", "rejected"].includes(loanData.status) && (
                            <Tooltip title="Edit Loan">
                                <IconButton
                                    sx={{ position: 'absolute', top: 8, right: 8 }}
                                    onClick={() => handleEditLoan(loanData._id)}
                                >
                                    <Edit />
                                </IconButton>
                            </Tooltip>
                        )}

                        {loanData.status === "disbursed" && (
                            <Tooltip title="Add Repayment">
                                <Button
                                    variant="outlined"
                                    startIcon={<LocalAtmIcon />}
                                    color="info"
                                    sx={{ fontSize: "14px", textTransform: "none" }}
                                    disabled={userType !== 'block'}
                                    onClick={() => navigate(`/loan/repayment/request/create/${loanData._id}`)}
                                >
                                    Add Repayment
                                </Button>
                            </Tooltip>
                        )}


                        <Grid container spacing={2} mt={2}>
                            {/* Enterprise Info */}
                            <Grid item xs={12} md={6}>
                                <Typography sx={{ fontSize: "16px" }}>Enterprise Info</Typography>
                                <Divider sx={{ my: 1 }} />
                                <Typography sx={{ lineHeight: "24px" }} variant="body2">Enterprise: {loanData.enterpriseName || "-"}</Typography>
                                <Typography sx={{ lineHeight: "24px" }} variant="body2">NHG Member: {loanData.nhgMemberName || "-"}</Typography>
                                <Typography sx={{ lineHeight: "24px" }} variant="body2">Relationship: {loanData.relationshipWithNhgMember || "-"}</Typography>
                            </Grid>

                            {/* NHG Info */}
                            <Grid item xs={12} md={6}>
                                <Typography sx={{ fontSize: "16px" }}>NHG Info</Typography>
                                <Divider sx={{ my: 1 }} />
                                <Typography sx={{ lineHeight: "24px" }} variant="body2">NHG: {loanData.nhgName}</Typography>
                                <Typography sx={{ lineHeight: "24px" }} variant="body2">ADS: {loanData.adsName}</Typography>
                                <Typography sx={{ lineHeight: "24px" }} variant="body2">CDS: {loanData.cds.name}</Typography>
                            </Grid>

                            {/* Location Info */}
                            <Grid item xs={12} md={6}>
                                <Typography sx={{ fontSize: "16px" }}>Location</Typography>
                                <Divider sx={{ my: 1 }} />
                                <Typography sx={{ lineHeight: "24px" }} variant="body2">CDS Code: {loanData.cds?.code}</Typography>
                                <Typography sx={{ lineHeight: "24px" }} variant="body2">Block Code: {loanData.block?.code}</Typography>
                                <Typography sx={{ lineHeight: "24px" }} variant="body2">District Code: {loanData.district?.code}</Typography>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>

            {/* Tabs Section */}
            <Divider sx={{ my: 3 }} />

            <Grid container spacing={3}>
                {/* Loan Details Card */}
                <Grid item xs={12} md={6}>
                    <Paper
                        elevation={1}
                        sx={{
                            p: 3,
                            height: '100%',
                            border: '1px solid',
                            borderColor: 'grey.200',
                            borderRadius: 2,
                        }}
                    >
                        <Typography variant="h6" fontWeight="600" gutterBottom>
                            Loan Details
                        </Typography>
                        <Divider sx={{ mb: 2 }} />

                        {/* Key Metric Highlight */}
                        <Box
                            sx={{
                                background: "linear-gradient(95.53deg, #4AD06E 0%, #08B1B6 100%)", // gradient applied
                                color: 'primary.contrastText',
                                p: 1.5,
                                borderRadius: 1,
                                mb: 2,
                                textAlign: 'center',
                            }}
                        >
                            <Typography variant="body2" fontWeight="500">
                                Sanctioned Amount
                            </Typography>
                            <Typography variant="h6" fontWeight="700">
                                ₹{loanData.sanctionedCefAmount?.toLocaleString('en-IN') || '0'}
                            </Typography>
                        </Box>

                        {/* Details List */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            <DetailItem label="Applied Amount" value={`₹${loanData.appliedAmount?.toLocaleString('en-IN')}`} />

                            <DetailItem label="Amount Disbursed" value={`₹${loanData.amountReceived ? loanData.amountReceived?.toLocaleString('en-IN') : 'N/A'}`} />
                            <DetailItem label="Repayment Tenure" value={`${loanData.repaymentMonths} Months`} />
                            <DetailItem label="Interest Rate" value={`${loanData.interestRate}%`} />
                            <DetailItem label="Sanctioned Date" value={loanData.sanctionedDate ? new Date(loanData.sanctionedDate).toLocaleDateString('en-GB') : 'N/A'} />
                            <DetailItem label="Loan Type" value={loanData.isGroupLoan ? 'Group Loan' : 'Individual Loan'} />

                            {/* Status Indicator */}
                            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                <Typography variant="body2" fontWeight="500" sx={{ mr: 1 }}>
                                    Status:
                                </Typography>
                                <Chip
                                    label={loanData.status?.charAt(0).toUpperCase() + loanData.status?.slice(1)}
                                    size="small"
                                    color={
                                        loanData.status === 'disbursed' ? 'success' :
                                            loanData.status === 'sanctioned' ? 'warning' :
                                                loanData.status === 'rejected' ? 'error' : 'default'
                                    }
                                    variant="outlined"
                                />
                            </Box>
                        </Box>
                    </Paper>
                </Grid>

                {/* Actions Card */}
                <Grid item xs={12} md={6}>
                    <Paper
                        elevation={2}
                        sx={{
                            p: 3,
                            height: '100%',
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 3,
                            background: 'linear-gradient(to bottom, #fafafa, #ffffff)',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                            }
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <Assignment color="primary" sx={{ mr: 1.5 }} />
                            <Typography variant="h6" fontWeight="700" color="primary.main">
                                Loan Actions
                            </Typography>
                        </Box>

                        <Divider sx={{ mb: 3 }} />

                        <Typography variant="body2" color="text.secondary" paragraph sx={{ mb: 3 }}>
                            Update the loan application status. Available actions depend on the current state.
                        </Typography>

                        {/* Display Rejection Reason if Status is Rejected */}
                        {loanData.status === 'rejected' && loanData.reasonForReject && (
                            <Alert
                                severity="error"
                                sx={{
                                    mb: 3,
                                    borderRadius: 2,
                                    '& .MuiAlert-message': {
                                        width: '100%'
                                    }
                                }}
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="subtitle2" fontWeight="600" gutterBottom>
                                        ❌ Rejection Reason
                                    </Typography>
                                    <Paper
                                        variant="outlined"
                                        sx={{
                                            p: 2,
                                            mt: 1,
                                            backgroundColor: 'error.50',
                                            borderColor: 'error.100',
                                            borderRadius: 2
                                        }}
                                    >
                                        <Typography variant="body2" color="error.dark">
                                            "{loanData.reasonForReject}"
                                        </Typography>
                                    </Paper>
                                    {loanData.rejectedAt && (
                                        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                                            Rejected on: {new Date(loanData.rejectedAt).toLocaleDateString('en-GB')}
                                        </Typography>
                                    )}
                                </Box>
                            </Alert>
                        )}


                        {loanData.status === 'completed' && loanData.updatedAt && (
                            <Alert
                                severity="success"
                                sx={{
                                    mb: 3,
                                    borderRadius: 2,
                                    '& .MuiAlert-message': {
                                        width: '100%',
                                    },
                                }}
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="subtitle2" fontWeight="600" gutterBottom>
                                        Loan Completed
                                    </Typography>
                                    <Paper
                                        variant="outlined"
                                        sx={{
                                            p: 2,
                                            mt: 1,
                                            backgroundColor: 'success.50',
                                            borderColor: 'success.100',
                                            borderRadius: 2,
                                        }}
                                    >
                                        <Typography variant="body2" color="success.dark">
                                            Your loan has been successfully completed. Thank you for your timely payments!
                                        </Typography>
                                    </Paper>
                                    {loanData.completedAt && (
                                        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                                            Completed on: {new Date(loanData.completedAt).toLocaleDateString('en-GB')}
                                        </Typography>
                                    )}
                                </Box>
                            </Alert>
                        )}

                        {/* Action Buttons Grid */}
                        <Grid container spacing={1.5}>
                            <ActionButton
                                color="error"
                                label="Reject"
                                onClick={() => handleAction("Reject")}
                                disabled={
                                    !isEditable ||
                                    loanData.status === 'rejected' ||
                                    loanData.status === 'disbursed'
                                }
                                icon={<Block fontSize="small" />}
                                currentStatus={loanData.status}
                                allowedStatus="pending"
                                tooltip={
                                    loanData.status === 'rejected'
                                        ? 'Loan already rejected'
                                        : loanData.status === 'disbursed'
                                            ? 'Cannot reject disbursed loan'
                                            : !isEditable
                                                ? 'You do not have permission to reject'
                                                : 'Reject this loan application'
                                }
                            />
                            <ActionButton
                                color="info"
                                label="Sanction"
                                onClick={() => handleAction("Sanction")}
                                disabled={!isEditable || loanData.status !== 'pending'}
                                icon={<Approval fontSize="small" />}
                                currentStatus={loanData.status}
                                allowedStatus="pending"
                                tooltip={
                                    loanData.status !== 'pending'
                                        ? 'Can only sanction pending loans'
                                        : !isEditable
                                            ? 'You do not have permission to sanction'
                                            : 'Approve and sanction this loan'
                                }
                            />
                            <ActionButton
                                color="warning"
                                label="Disburse"
                                onClick={() => handleAction("Disburse")}
                                disabled={loanData.status !== 'sanctioned'}
                                icon={<AccountBalance fontSize="small" />}
                                currentStatus={loanData.status}
                                allowedStatus="sanctioned"
                                // tooltip={
                                //     loanData.status !== 'sanctioned'
                                //         ? 'Can only disburse sanctioned loans'
                                //         : !isEditable
                                //             ? 'You do not have permission to disburse'
                                //             : 'Disburse funds for this loan'
                                // }

                                tooltip={
                                    loanData.status !== 'sanctioned'
                                        ? 'Can only disburse sanctioned loans'
                                        : 'Disburse funds for this loan'
                                }
                            />
                            <ActionButton
                                color="success"
                                label="Complete & Close"
                                onClick={() => handleAction("Complete")}
                                disabled={loanData.status !== 'completed'}
                                icon={<CheckCircle fontSize="small" />}
                                currentStatus={loanData.status}
                                allowedStatus="completed"
                                tooltip={
                                    loanData.status !== 'completed'
                                        ? 'Can only make close the loan after repayments completed!'
                                        : !isEditable
                                            ? 'You do not have permission to complete'
                                            : 'Mark this loan as completed'
                                }
                            />
                        </Grid>

                        {/* Status Guide */}
                        <Box sx={{ mt: 3, pt: 2, borderTop: '1px dashed', borderColor: 'divider' }}>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center' }}>
                                <InfoOutlined sx={{ fontSize: 14, mr: 0.5 }} />
                                Status flow: Pending → Sanctioned → Disbursed → Completed
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>

                {loanData.hasMoratorium &&
                    <MoratoriumData loanData={loanData} />
                }

                {/* <LoanStatement loanId={loanData._id} /> */}

                {/* loan reject modal (popup) */}
                <LoanRejectDialog openRejectModal={openRejectModal}
                    rejectionReason={rejectionReason} statusChanging={statusChanging}
                    handleCloseRejectModal={handleCloseRejectModal}
                    handleReject={handleRejectLoan} setRejectionReason={setRejectionReason} />

                {/* EMI Schedule Section */}
                {emiData.schedule.length > 0 && <Grid item xs={12}>
                    <EmiSchedules loanData={loanData} payingBulk={payingBulk}
                        emiData={emiData} page={page} rowsPerPage={rowsPerPage}
                        setPage={setPage} setRowsPerPage={setRowsPerPage}
                        handleDownload={handleDownload} handleRepaymentClick={handleRepaymentClick}
                        handleBulkRepayment={handleBulkRepayment} selectedEmis={selectedEmis} setSelectedEmis={setSelectedEmis} />
                </Grid>}
                {
                    // loan repayment history component
                    userType !== 'district' && <Grid item xs={12}>
                        <LoanRepaymentTable loanId={loanData._id} loanStatus={loanData.status} fetchRepayment={fetchRepayment} handleCorrectionClick={handleCorrectionClick} />
                    </Grid>
                }


                {/* Documents & Actions */}
                {loanData.documents.length > 0 && <Grid item xs={12}>
                    <Paper elevation={2} sx={{ p: 2 }}>
                        <Typography sx={{ fontSize: "16px" }}>Documents</Typography>
                        <Divider sx={{ my: 1 }} />
                        {loanData.documents?.length ? loanData.documents.map((doc: any, i: number) => (
                            <Typography key={i}><a href={doc.fileUrl} target="_blank" rel="noreferrer">{doc.name}</a></Typography>
                        )) : <Typography>No documents</Typography>}
                        <Button variant="outlined" startIcon={<Download />} onClick={handleDownloadAll} sx={{ mt: 2 }}>
                            Download All
                        </Button>
                    </Paper>
                </Grid>}
            </Grid>
            <EmiDialog
                control={control}
                handleConfirmPayment={handleConfirmPayment}
                openPayDialog={openPayDialog}
                selectedEmi={selectedEmi}
                emiData={emiData}
                setOpenPayDialog={setOpenPayDialog} handleSubmit={handleSubmit} submitting={submitting} />

            <EmiCorrectionDialog correctionForm={correctionForm} correctionOpen={correctionOpen}
                handleSubmitCorrectionRequest={handleSubmitCorrectionRequest}
                setCorrectionForm={setCorrectionForm} setCorrectionOpen={setCorrectionOpen} />

            {userType === 'district' && <EmiApproveOrReject loadingCorrection={loadingCorrection}
                corrections={corrections} handleApprove={handleApprove} handleReject={handleRejectRepaymentRequest} />}

            <WSLoadingOverlay loading={statusChanging || downloading} />
        </Box>
    );
};

export default LoanDetailPage;

interface DetailItemProps {
    label: string;
    value: string | number | React.ReactNode;
}

const DetailItem: React.FC<DetailItemProps> = ({ label, value }) => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="body2" color="text.secondary" fontWeight="500">
            {label}:
        </Typography>
        <Typography variant="body2" fontWeight="400">
            {value}
        </Typography>
    </Box>
);